import T from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import {
  fetchWidgetRateLogTable,
  removeLogRow,
  clearWidgetRateLogTable,
  reloadWidgetRateLogTable,
} from 'reducers/digitalLogbook/reducer'
import { reloadCageList } from 'reducers/slaMonitor/reducer'
import ListFromTable from 'components/common/ListFromTable'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import withPromise from 'helpers/withPromise'
import { getTime } from 'helpers/timeFrames'
import Sort from 'lib/psfs/Sort'
import messages from '../translate'

class LogTable extends ListFromTable {
  static contextTypes = {
    router: T.shape({
      history: T.object.isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)
    this.deleteEntity = this.props.removeLogRow
    this.clearReducerState = this.props.clearWidgetRateLogTable
    this.asyncData = true
    this.loadingData = true
  }

  componentDidMount() {
    const { activeSite, activeDate } = this.props
    this.psfs.addSort('time', Sort.DESC)
    this.getTableData(activeSite, activeDate, this.psfs)
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { activeSite, activeDate, tableData } = this.props

    if (
      activeSite !== nextProps.activeSite ||
      activeDate !== nextProps.activeDate ||
      nextState.pathname !== this.state.pathname ||
      nextProps.isReloadWidgetRateLogTable
    ) {
      this.psfs.init(nextState.pathname)
      this.getTableData(nextProps.activeSite, nextProps.activeDate, this.psfs)

      return false
    }

    if (tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return true
  }

  getTableData = (activeSite, activeDate, psfs) => {
    this.props.fetchWidgetRateLogTable({
      siteId: activeSite,
      cageId: 0,
      date: activeDate.format('YYYY-MM-DD'),
      psfs,
    })
  }

  getTableProps() {
    return {
      title: this.props.intl.formatMessage(messages.logbookHistory),
      showFilterBar: false,
      sorting: true,
      paging: true,
      searching: false,
      creating: false,
      responsive: true,
    }
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.deleteLog),
      message: formatMessage(messages.deleteLogMessage),
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
    } = this.props
    const columns = new ColumnCollection()
    columns.add(
      new Column('containerName', formatMessage(messages.cage), {
        sorting: true,
        render: rowData => rowData.cagename,
      }),
    )
    columns.add(
      new Column('status', formatMessage(messages.status), {
        sorting: true,
        render: () => formatMessage(messages.completed),
      }),
    )
    columns.add(
      new Column('username', formatMessage(messages.logged), { sorting: true }),
    )
    columns.add(new Column('comment', formatMessage(messages.comment)))
    columns.add(
      new Column('time', formatMessage(messages.time), {
        sorting: true,
        render: rowData => getTime(rowData.hour, rowData.minute),
      }),
    )
    columns.add(
      new Column('rate', formatMessage(messages.value), {
        sorting: true,
        render: rowData => (rowData.rate === 5 ? 'X' : rowData.rate),
      }),
    )

    return columns
  }

  onConfirmActionConfirmDialog = () => {
    const { confirmParams } = this.state

    if (confirmParams) {
      withPromise(this.deleteEntity, confirmParams).then(errors => {
        if (errors) {
          return Promise.resolve(errors)
        }

        this.props.reloadCageList(true)
        this.props.reloadWidgetRateLogTable(true)
      })
    }

    this.onCloseConfirmDialog()
  }

  getActions() {
    const {
      activeSite,
      activeDate,
      intl: { formatMessage },
    } = this.props
    const actions = new ActionCollection()
    actions.add(
      new Action('delete', formatMessage(messages.removeEntry), row => {
        this.onOpenConfirmDialog({
          logId: row.id,
          siteId: activeSite,
          cageId: 0,
          date: +activeDate.format('YYYYMMDD'),
          psfs: this.psfs,
        })
      }),
    )

    return actions
  }
}

export default connect(
  state => ({
    isReloadWidgetRateLogTable: state.getIn([
      'digitalLogbook',
      'isReloadWidgetRateLogTable',
    ]),
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['slaMonitor', 'activeDate']),
    tableData: state.getIn(['digitalLogbook', 'widgetRateLogTable']),
  }),
  {
    fetchWidgetRateLogTable,
    removeLogRow,
    clearWidgetRateLogTable,
    reloadCageList,
    reloadWidgetRateLogTable,
  },
)(injectIntl(LogTable))
